<template>
  <Loader :value="promises.fetchOne" theme="default">
    <Statistics :item="item" :addons="addons" :items="items" type="page" />
  </Loader>
</template>

<script>
import { mapState } from 'vuex'
import Statistics from '@/components/Dashboard/Statistics'

export default {
  props: {
    addons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      value: 'analytics',
    }
  },
  computed: {
    ...mapState('Page', ['item', 'promises']),

    items() {
      return [{ id: 'analytics', label: this.$t('statisticsVisitors') }].filter(
        item => !('condition' in item) || item.condition,
      )
    },
  },

  components: {
    Statistics,
  },
}
</script>
